document.addEventListener('turbolinks:load', function () {
    if ($('#applicantPortalSetting, #applicantPortalModal').length === 0) {
        return false
    }

    const modalEl = document.getElementById('applicantPortalModal');
    const bsModal = new bootstrap.Modal(modalEl)

    $(document).on('change', "#organization_contractor_portal_enabled", function () {
        if ($(this).is(':checked')) {
            bsModal.show();
        }
    })

    var confirmationInput = $('.confirmation-input')
    $(document).on('change', ".radio-options input[type='radio']", function () {
        if ($('.radio-options input:radio:checked').length > 0) {
            $(confirmationInput).removeClass('d-none')
        } else {
            $(confirmationInput).addClass('d-none')
        }
    })

    var submitBtn = $('#applicantPortalModal .submit-button')
    $(document).on('keyup', '.confirmation-input #confirmation-text', function () {
        if ($(this).val() === 'Yes') {
            $(submitBtn).removeClass('disabled')
        } else {
            $(submitBtn).addClass('disabled')
        }
    })

    var confirmationTextField = $(confirmationInput).find('#confirmation-text')
    $('.cancelBtn').on('click', function () {
        if ($('.radio-options input:radio:checked').length === 0 || $(confirmationTextField).val() !== 'Yes') {
            $('#organization_contractor_portal_enabled').prop('checked', false)
            $(".radio-options input[type='radio']").prop('checked', false).trigger('change')
            $(confirmationTextField).val('')
        }
    })

    $('.confirmBtn').on('click', function () {
        bsModal.hide();
    })

    $(".radio-options input[type='radio']").trigger('change')
});